import FilePreviewComponent from "@/components/probaworkflows_base_components/FilePreviewComponent/FilePreviewComponent.vue";
import {
  COUNT_APPLICATION_DOCUMENTS_URL,
  COUNT_SUB_ENTITIES_URL,
  GET_APPLICATION_DOCUMENTS,
  GET_ENTITY_COMPLIANCE_OVERVIEW_URL,
  get_headers
} from '@/utils/constants/constants';
import alert_mixin from "@/utils/mixins/alert_mixin";
import axios from 'axios';

export default {
  mixins: [alert_mixin],
  components: {
    FilePreviewComponent
  },

  data: () => ({
      entity_name: '',
      application_id: null,
      entity_profile_id: null,
      entity_type_id: null,
      entity_type_name: '',
      showAlert: true,
      metrics: [
        {
          label: 'Active Employees',
          value: 0,
          icon: 'bx bx-group me-1 text-white',
          iconBg: 'bg-secondary bg-opacity-25'
        },
        {
          label: 'Employee Documents',
          value: 0,
          icon: 'bi bi-file-earmark-text text-white',
          iconBg: 'bg-secondary bg-opacity-25'
        },
      ],
      meetings: [
        {
          id: 2,
          type: 'Annual General Meeting',
          title: 'Annual General Meeting',
          date: '15 Feb 2025',
          time: '10:00 AM',
          badgeClass: 'bg-success-subtle text-success'
        },
        {
          id: 3,
          type: 'Special Meeting',
          title: 'Special Resolution - Amendment',
          date: '22 Feb 2025',
          time: '10:00 AM',
          badgeClass: 'bg-warning-subtle text-warning'
        }
      ],
      document_counts_loading: false,
      document_counts: {
        application_documents: 0,
        submission_documents: 0,
        journal_documents: 0,
        additional_documents: 0,
        total_documents: 0,
      },
      recentDocuments: [],

      // File preview state
      show_file_preview: false,
      preview_file_url: '',
      preview_file_name: '',
      recent_documents_loading: false,
      is_loading_stats: false,
      sub_entity_stats: {
        total: 0,
        active: 0,
      },
      compliance_score: {
        value: 0,
        label: 'Loading...',
        colorClass: 'text-muted',
      },
  }),

  mounted() {
    this.application_id = this.$route?.query?.application_id || sessionStorage.getItem('application_id');
    this.entity_profile_id = this.$route?.query?.entity_profile_id || sessionStorage.getItem('entity_profile_id');
    this.entity_type_id = this.$route?.query?.entity_type_id || sessionStorage.getItem('entity_type_id');
    this.entity_type_name = this.$route?.query?.entity_type_name || sessionStorage.getItem('entity_type_name') || '';
    this.entity_name = sessionStorage.getItem('entity_name');
    this.fetch_document_counts();
    this.fetch_recent_documents();
    this.fetch_sub_entity_stats();
     this.load_compliance_tasks();
  },
  methods: {

    viewCalendar() {
      // calendar logic
    },

    view_all_documents() {
      sessionStorage.setItem('active_tab', 'Documents');
      sessionStorage.setItem('active_master_tab', 'documents');
      sessionStorage.setItem('came_from_dashboard', 'true');

      this.$router.push({
        path: '/entity_application_overview',
        query: {
          application_id: this.application_id,
          entity_profile_id: this.entity_profile_id,
          entity_type_id: this.entity_type_id,
          entity_name: this.entity_name,
          entity_type_name: this.entity_type_name,
        }
      });
    },

    fetch_document_counts() {
      const application_id = Number(this.application_id || 0);
      const entity_profile_id = Number(this.entity_profile_id || 0);
      if (!application_id) return;

      this.document_counts_loading = true;

      axios.get(COUNT_APPLICATION_DOCUMENTS_URL, {
        headers: get_headers(),
        params: {
          application_id,
          ...(entity_profile_id ? { entity_profile_id } : {}),
        },
      })
        .then((response) => {
          const body = response.data;

          if (body?.status === 'success' && body?.data) {
            this.document_counts = { ...body.data };

            const docMetric = this.metrics.find(m => m.label === 'Supplier Documents');
            if (docMetric) {
              docMetric.value = body.data.total_documents;
            }
          } else {
            this.show_error('Unexpected response from document count API:', body);
          }
        })
        .catch((error) => {
          this.show_error(
            'Error fetching document counts:',
            error.response?.data?.message || error.message
          );
        })
        .finally(() => {
          this.document_counts_loading = false;
        });
    },

    fetch_recent_documents() {
      const application_id = Number(this.application_id || 0);
      const entity_profile_id = Number(this.entity_profile_id || 0);
      if (!application_id) return;

      this.recent_documents_loading = true;

      axios.get(GET_APPLICATION_DOCUMENTS, {
        headers: get_headers(),
        params: {
          application_id,
          ...(entity_profile_id ? { entity_profile_id } : {}),
        },
      })
        .then((response) => {
          const docs = response.data?.data || [];

          this.recentDocuments = docs
            .sort((a, b) => new Date(b.submitted_on) - new Date(a.submitted_on))
            .slice(0, 3)
            .map(doc => ({
              name: doc.file_name,
              date: new Date(doc.submitted_on).toLocaleDateString(),
              presigned_url: doc.presigned_url,
            }));
        })
        .catch((error) => {
          this.show_error('Error loading recent documents: ' + (error.response?.data?.message || error.message));
        }).finally(() => {
          this.recent_documents_loading = false;
        });
    },

    open_file_preview(doc) {
      this.preview_file_url = doc.presigned_url;
      this.preview_file_name = doc.name;
      this.show_file_preview = true;
    },

    close_file_preview() {
      this.show_file_preview = false;
      this.preview_file_url = '';
      this.preview_file_name = '';
    },

    fetch_sub_entity_stats() {
      const entity_profile_id = this.entity_profile_id;
      if (!entity_profile_id) return;

      this.is_loading_stats = true;

      axios.get(COUNT_SUB_ENTITIES_URL, {
        headers: get_headers(),
        params: { entity_profile_id },
      })
        .then((response) => {
          if (response.data?.status === 'success') {
            this.sub_entity_stats.total = response.data.sub_entity_count || 0;
            this.sub_entity_stats.active = response.data.active_sub_entity_count || 0;

            // Update the metric value reactively
            const empMetric = this.metrics.find(m => m.label === 'Active Employees');
            if (empMetric) empMetric.value = this.sub_entity_stats.total;
          }
        })
        .catch((err) => {
          this.show_error('Failed to load employee stats:', err);
        })
        .finally(() => {
          this.is_loading_stats = false;
        });
    },

    async load_compliance_tasks() {
        const entity_profile_id = this.entity_profile_id;
        if (!entity_profile_id) {
            return;
        }
        this.is_loading_tasks = true;
        this.tasks = [];
        this.more_unanswered_count = 0;

        try {
          const response = await axios.get(GET_ENTITY_COMPLIANCE_OVERVIEW_URL, {
            params: { entity_profile_id: entity_profile_id },
            headers: get_headers(),
          });

          if (response.data.status === 'success') {
            const overview_data = response.data.data;
            const actionable_items = overview_data.actionable_items || [];

            this.tasks = actionable_items.map(doc => this.format_task(doc)).slice(0, 3);
            this.more_unanswered_count = Math.max(0, actionable_items.length - 3);

            this.calculate_stats(overview_data, actionable_items);
          }
        } catch (error) {
          console.warn('Error loading compliance tasks:', error);
          this.tasks = [];
        } finally {
          this.is_loading_tasks = false;
        }
      },

    calculate_stats(overview_data) {
      const rules = overview_data.rules || [];
      const compliant_count = rules.filter(r => r.answered_count === r.total_questions).length;
      const compliance_rate = rules.length > 0
          ? Math.round((compliant_count / rules.length) * 100)
          : 0;

      this.compliance_score.value = compliance_rate;
      this.compliance_score.label = compliance_rate >= 80
          ? 'Excellent'
          : compliance_rate >= 50
          ? 'Needs Attention'
          : 'Action Required';
      this.compliance_score.colorClass = compliance_rate >= 80
          ? 'text-success'
          : compliance_rate >= 50
          ? 'text-warning'
          : 'text-danger';
    },

    format_task(doc) {
      const compliance_item = {
        id: doc.compliance_field_id,
        compliance_field_id: doc.compliance_field_id,
        priority: doc.priority || 'orange',
        title: doc.title,
        description: doc.description,
        deadline: doc.deadline || 'Awaiting response',
        deadlineClass: doc.priority === 'red' ? 'tag-red' : 'tag-orange',
        tags: [doc.rule_name || 'Compliance'],
        btnText: 'Answer Question',
        btnClass: doc.priority === 'red' ? 'btn-success' : 'btn-outline-secondary',
      };

      return compliance_item;
    }

  }
};